import service from '@/utils/request';

// @Summary 获取game列表
// @Produce  application/json
// @Param {
//  page     int
//	pageSize int
// }
// @Router /game/gameList [post]
export var getFirst = function getFirst(params) {
  return service({
    url: "/formConfig/first",
    method: 'get',
    params: params
  });
};
export var apiRequest = function apiRequest(data) {
  return service({
    url: "/formConfig/apiRequest",
    method: 'post',
    data: data
  });
};